import { takeLatest, put, call, select } from 'redux-saga/effects';
import { get } from 'lodash';
import { changePassword, getLanguagesList, getAccessRequests } from '../../utils/API';
import { changePasswordAction, getLanguages, updateSettingsProperty, getAccessRequestsAction } from './actions';
import { selectUserData } from '../App/selectors';
import { getSettingsSaga, getUserFromData } from '../App/saga';

const { updateSettingsField } = require('../../utils/API');

export function* loadLanguagesList() {
  try {
    const response = yield call(getLanguagesList);
    yield put(getLanguages.success(get(response, 'data.data', [])));
  } catch (err) {
    yield put(getLanguages.failure(err));
  } finally {
    yield put(getLanguages.fulfill());
  }
}

export function* getAccessRequestsSaga() {
  try {
    const userData = yield select(selectUserData());
    const userId = get(userData, 'id');
    if (!userId) {
      throw new Error('User undefined');
    }
    const accesRequestsData = yield call(getAccessRequests);
    yield put(getAccessRequestsAction.success(get(accesRequestsData, 'data')));
  } catch (err) {
    yield put(getAccessRequestsAction.failure(err));
  } finally {
    yield put(getAccessRequestsAction.fulfill());
  }
}

export function* updateSettingsPropertySaga({ payload }) {
  try {
    const user = yield select(selectUserData());
    const id = get(user, 'id');
    if (id) {
      yield call(updateSettingsField, id, get(payload, 'identifier'), get(payload, 'value'));
      yield call(getSettingsSaga, id);
      if (payload.callback && typeof payload.callback === 'function') {
        payload.callback();
      }
    }
  } catch (err) {
    yield put(updateSettingsProperty.failure(err));
  } finally {
    yield put(updateSettingsProperty.fulfill());
  }
}

export function* changePasswordSaga({ payload }) {
  try {
    const user = yield call(getUserFromData);
    const userId = get(user, 'id');
    const oldPassword = get(payload, 'password');
    const newPassword = get(payload, 'newPassword');
    yield call(changePassword, userId, oldPassword, newPassword);
    yield put(changePasswordAction.success());
  } catch (err) {
    yield put(changePasswordAction.failure(err));
  } finally {
    yield put(changePasswordAction.fulfill());
  }
}

export default function* dataPerformances() {
  yield takeLatest(getLanguages.TRIGGER, loadLanguagesList);
  yield takeLatest(updateSettingsProperty.TRIGGER, updateSettingsPropertySaga);
  yield takeLatest(changePasswordAction.TRIGGER, changePasswordSaga);
  yield takeLatest(getAccessRequestsAction.TRIGGER, getAccessRequestsSaga);
}
